var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-down"},[_c('p',[_vm._v("SCROLL")]),_c('span',{staticClass:"icon-arr"}),_c('div',{staticClass:"line-box"},[_c('span',{staticClass:"line line-left"}),_c('i',{staticClass:"icon-block"}),_c('span',{staticClass:"line line-right"})])])
}]

export { render, staticRenderFns }